import { useBusEmitterListener } from "./index";

const loadingFailedEvent = Symbol("bridge:loadingFailed");
export const {
  emitter: loadingFailed,
  listener: onLoadingFailed,
} = useBusEmitterListener(loadingFailedEvent);
